import { IoClose } from "react-icons/io5";
import CuInput from "../../all-patient/components/CuInput";
import CuSuggestionBox from "../../common_component/component/CuSuggestionBox";
import { useEffect, useState } from "react";
import {
  useItemsFilter,
  useItemsFilterNew,
} from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import BatchSuggestionList from "./BatchSuggestionList";
import { toast } from "react-toastify";
import "../css/PLine.css";
import { MdAdd } from "react-icons/md";
import {
  calculateDiscountedPrice,
  validateDiscAmt,
} from "../helpers/_invoiceHelpers";

const PLine = ({
  pline,
  idx,
  invoiceData,
  setInvoiceData,
  isView,
  lineLevelDisc,
  setPharmacyLines,
  pharmacyLines,
}) => {
  const [searchInput, setSearchInput] = useState({
    pline: "",
    mainLine: "",
    uom: "",
    batch_no: "",
  });
  const [clinic] = useAtom(clinicAtom);
  const [isBatchSuggestion, setIsBatchSuggestion] = useState(false);
  // const [toastId, setToastId] = useState(null);
  // const [selectedMedicine, setSelectedMedicine] = useState(null);

  const { data: medicines, isLoading: medicineLoading } = useItemsFilter(
    `master_data/medicine_with_batch/`,
    `?clinic_id=${clinic?.id}&name=${searchInput?.pline}`,
    searchInput?.pline?.length > 0 ? true : false,
    "",
    0
  );

  const { data: unitData, isLoading: uomLoading } = useItemsFilterNew(
    ApiEndPoint.CLINIC,
    `?action=getUnitsOfMeasure&clinic_id=${clinic?.id}&backend=True&name=${searchInput?.uom}`,
    clinic?.id && searchInput?.uom?.length > 0 ? true : false,
    (res) => res?.data
  );

  const getBatchSuggestions = (response) => {
    return response.data;
  };

  // const { data: batchData, isLoading: batchLoading } = useItemsFilterNew(
  //   ApiEndPoint.INVENTORY,
  //   `?action=getBatchMaster&backend=True&clinic_id=${clinic?.id}&medicine_id=${pline?.medicine_id}&is_consumed=True`,
  //   clinic?.id && pline?.medicine_id ? true : false,
  //   getBatchSuggestions,
  //   0
  // );

  // const { data: medicineStock, isLoading: medicineStockLoading } =
  //   useItemsFilter(
  //     "inventory/",
  //     `?action=getMedicineStock&backend=true&clinic_id=${clinic?.id}&master_data_id=${selectedMedicine?.data?.id}`,
  //     clinic?.id && selectedMedicine?.data?.id ? true : false,
  //     "",
  //     0
  //   );

  const handleSearch = (value, label) => {
    setSearchInput({
      pline: "",
      mainLine: "",
      uom: "",
      batch_no: "",
      [label]: value,
    });
  };

  const clearInput = () => {
    setSearchInput({ pline: "", mainLine: "", uom: "", batch_no: "" });
  };

  const calculatePLinesTotal = () => {
    let total = 0;
    for (let i of pharmacyLines) {
      const { price, quantity, discount, discount_type } = i;
      const totalAmt = Number(price) * Number(quantity);
      const discountTotal = calculateDiscountedPrice(
        totalAmt,
        discount,
        discount_type
      );
      total += Number(discountTotal);
    }

    const discount = invoiceData?.discount;
    const discountType = invoiceData?.discount_type;
    const isValidate = validateDiscAmt(total, discount, discountType);
    let grandTotal = total;

    if (isValidate) {
      grandTotal = calculateDiscountedPrice(total, discount, discountType);
    }
    setInvoiceData((prev) => ({ ...prev, invoice_total: Number(grandTotal) }));
    // return grandTotal;
  };

  const calculatePLine = (pline) => {
    const { price, quantity, discount, discount_type } = pline;
    const totalAmt = Number(price) * Number(quantity);
    const discountTotal = calculateDiscountedPrice(
      totalAmt,
      discount,
      discount_type
    );
    return discountTotal;
  };

  const handlePLineChange = (value, label, idx) => {
    if (label === "medicine") {
      setPharmacyLines((prev) => {
        const temp = [...prev];
        temp[idx] = { ...temp[idx], ...value };
        return temp;
      });
      return;
    }
    if (label === "quantity") {
      if (Number(value) < 0) {
        return;
      }
      setPharmacyLines((prev) => {
        const temp = [...prev];
        temp[idx] = { ...temp[idx], [label]: Number(value) };
        const linesTotal = calculatePLine(temp[idx]);
        temp[idx] = { ...temp[idx], total: linesTotal };
        return temp;
      });
      return;
    }
    if (label === "discount") {
      if (Number(value) < 0) {
        return;
      }
      const type = pharmacyLines[idx]?.discount_type;
      const total =
        Number(pharmacyLines[idx]?.price) *
        Number(pharmacyLines[idx]?.quantity);
      const isValidate = validateDiscAmt(total, value, type);
      if (isValidate) {
        setPharmacyLines((prev) => {
          const temp = [...prev];
          temp[idx] = { ...temp[idx], [label]: value };
          const linesTotal = calculatePLine(temp[idx]);
          temp[idx] = { ...temp[idx], total: linesTotal };
          return temp;
        });
      }
      return;
    }
    if (label === "price") {
      if (Number(value) < 0) {
        return;
      }
      setPharmacyLines((prev) => {
        const temp = [...prev];
        temp[idx] = { ...temp[idx], [label]: value };
        const linesTotal = calculatePLine(temp[idx]);
        temp[idx] = { ...temp[idx], total: linesTotal };
        return temp;
      });
      return;
    }
    setPharmacyLines((prev) => {
      const temp = [...prev];
      temp[idx] = { ...temp[idx], [label]: value };
      return temp;
    });
  };

  const handleSelectMedicine = (val, idx) => {
    let extracted;
    if (val?.medicine_stock?.length > 0) {
      extracted = {
        medicine_id: val?.id || null,
        medicine_name: val?.medicine_name || "",
        generic_name: val?.generic_name?.name || "",
        price: val?.medicine_stock[0]?.price || 0,
        uom: val?.medicine_stock[0]?.uom || "",
        medicine_stock: JSON.parse(JSON.stringify(val?.medicine_stock)),
      };
    } else {
      extracted = {
        id: null,
        medicine_name: "",
        generic_name: "",
        price: 0,
        uom: "",
      };
      toast.error("This medicine is out of stock");
    }
    handlePLineChange(extracted, "medicine", idx);
    // setSelectedMedicine({ data: value, idx });
    clearInput();
  };

  const handleSelectUom = (val, idx) => {
    handlePLineChange(val?.name, "uom", idx);
    clearInput();
  };

  const getCheckedBatches = (batchId) => {
    const existingIdx = pline?.batch_no?.findIndex(
      (ele) => ele?.batchId === batchId
    );
    if (existingIdx > -1) {
      return true;
    } else {
      return false;
    }
  };

  const handleSelectBatch = (e, batch, idx) => {
    const flag = e.target.checked;
    if (flag) {
      setPharmacyLines((prev) => {
        const temp = [...prev];
        const selectedBatches = temp[idx]?.batch_no || [];
        // selectedBatches.push(batch?.id);
        selectedBatches.push({
          batchId: batch?.batch_id,
          batchQty: batch?.avilable_batch_qty,
          batchNo: batch?.batch_number,
          expiry: batch?.expiry_date,
        });
        temp[idx] = { ...temp[idx], batch_no: selectedBatches };
        return temp;
      });
    } else {
      setPharmacyLines((prev) => {
        const temp = [...prev];
        const selectedBatches = temp[idx]?.batch_no || [];
        const filteredBatch =
          selectedBatches?.filter((bt) => bt?.batchId !== batch?.batch_id) || [];
        temp[idx] = { ...temp[idx], batch_no: filteredBatch };
        return temp;
      });
    }
  };

  const addPLine = () => {
    const newPline = {
      clinic_id: clinic?.id,
      id: null,
      medicine_id: null,
      medicine_name: "",
      generic_name: "",
      quantity: 0,
      batch_no: [],
      uom: "",
      price: 0,
      discount: 0,
      discount_type: "percentage",
      total: 0,
    };
    setPharmacyLines((prev) => [...prev, newPline]);
  };

  const deletePLine = (idx) => {
    if (pharmacyLines?.length === 1) {
      const newPline = {
        // clinic_id: clinic?.id,
        // id: null,
        medicine_id: null,
        medicine_name: "",
        generic_name: "",
        quantity: 0,
        batch_no: [],
        uom: "",
        price: 0,
        discount: 0,
        discount_type: "percentage",
        total: 0,
      };
      setPharmacyLines([newPline]);
    } else {
      setPharmacyLines((prev) => {
        const temp = [...prev];
        temp?.splice(idx, 1);
        return temp;
      });
    }
  };

  const handleBatchInputClick = () => {
    setIsBatchSuggestion((prev) => !prev);
  };

  let batchNos = "";
  pline?.batch_no?.forEach((ele) => {
    batchNos += `${ele?.batchNo}, `;
  });

  // useEffect(() => {
  //   if (medicineStock && selectedMedicine) {
  //     let extracted = {
  //       medicine_id: selectedMedicine?.data?.id || null,
  //       medicine_name: selectedMedicine?.data?.medicine_name || "",
  //       generic_name: selectedMedicine?.data?.generic_name?.name || "",
  //       price: medicineStock?.length > 0 ? medicineStock[0]?.price : 0,
  //       uom: medicineStock?.length > 0 ? medicineStock[0]?.uom : "",
  //     };

  //     if (medicineStock?.length === 0) {
  //       extracted = {
  //         id: null,
  //         medicine_name: "",
  //         generic_name: "",
  //         price: 0,
  //         uom: "",
  //       };
  //       toast.error("This medicine is out of stock");
  //     }

  //     handlePLineChange(extracted, "medicine", selectedMedicine?.idx);
  //     setSelectedMedicine(null);
  //   }
  // }, [medicineStock, selectedMedicine]);

  // useEffect(() => {
  //   if (medicineStockLoading) {
  //     const id = toast.loading(
  //       "Wait we are checking the stock of selected medicine"
  //     );
  //     setToastId(id);
  //   } else {
  //     toast.update(toastId, {
  //       render: "Stock loaded successfully!",
  //       type: "success",
  //       isLoading: false,
  //       autoClose: 3000,
  //     });
  //   }
  // }, [medicineStockLoading]);

  // useEffect(() => {
  //   if (batchLoading) {
  //     const id = toast.loading("Wait we are loading batch");
  //     setToastId(id);
  //   } else {
  //     toast.update(toastId, {
  //       render: "Batch loaded successfully!",
  //       type: "success",
  //       isLoading: false,
  //       autoClose: 3000,
  //     });
  //   }
  // }, [batchLoading]);

  useEffect(() => {
    calculatePLinesTotal();
  }, [pharmacyLines]);

  return (
    <div className="cu-invoice-pline-cont">
      <div>
        <CuSuggestionBox
          options={medicines}
          label="Medicine Name"
          renderKey={"medicine_name"}
          searchInput={searchInput?.pline}
          loading={medicineLoading}
          position={"calc(50% + 3px)"}
          searchable
          setSearchInput={(val) => handleSearch(val, "pline")}
          onChange={(val) => handlePLineChange(val, "medicine_name", idx)}
          handleSelectOption={(val) => handleSelectMedicine(val, idx)}
          value={pline?.medicine_name}
          disabled={isView}
        />
      </div>
      <div>
        <CuInput
          type={"number"}
          placeholder={"select"}
          label="Quantity"
          value={pline?.quantity}
          onChange={(e) => handlePLineChange(e.target.value, "quantity", idx)}
          disabled={isView || !pline?.medicine_id}
        />
      </div>
      <div>
        <CuInput
          type="text"
          label="Batch No"
          onClick={handleBatchInputClick}
          value={batchNos}
          // loading={batchLoading}
          position="calc(50% - -3px)"
          disabled={isView || !pline?.medicine_id}
        />
        {isBatchSuggestion && pline?.medicine_stock?.length > 0 && (
          <div className="flex flex-col absolute border rounded z-[5] bg-[#FFFFFF]">
            {pline?.medicine_stock?.map((batch) => (
              <BatchSuggestionList
                key={batch?.batch_id}
                batch={batch}
                handleSelectBatch={handleSelectBatch}
                getCheckedBatches={getCheckedBatches}
                idx={idx}
              />
            ))}
          </div>
        )}
      </div>
      <div>
        <CuSuggestionBox
          options={unitData}
          label={"UOM"}
          renderKey={"name"}
          loading={uomLoading}
          position="calc(50% - -2px)"
          searchInput={searchInput?.uom}
          searchable
          setSearchInput={(val) => handleSearch(val, "uom")}
          onChange={(val) => handlePLineChange(val, "uom", idx)}
          handleSelectOption={(val) => handleSelectUom(val, idx)}
          value={pline?.uom}
          disabled={isView || !pline?.medicine_id}
        />
      </div>
      <div>
        <CuInput
          type={"number"}
          label="Price"
          placeholder={"select"}
          value={pline?.price}
          disabled={isView || !pline?.medicine_id}
          onChange={(e) => handlePLineChange(e.target.value, "price", idx)}
        />
      </div>
      <div>
        <div className="cu-invoice-pline-discount-label">
          <label>Discount</label>
          <input
            type="checkbox"
            disabled={!lineLevelDisc}
            checked={pline?.discount_type === "amount" ? false : true}
            onChange={() => {}}
            onClick={(e) =>
              handlePLineChange(
                pline?.discount_type === "amount" ? "percentage" : "amount",
                "discount_type",
                idx
              )
            }
          />
        </div>
        <CuInput
          type={"number"}
          placeholder={"select"}
          disabled={!lineLevelDisc}
          value={pline?.discount}
          onChange={(e) => handlePLineChange(e.target.value, "discount", idx)}
        />
      </div>
      <div className="cu-invoice-pline-INR-field">
        <label>INR</label>
        <div className="cu-invoice-pline-INR text-[26px]">{pline?.total}</div>
      </div>
      <div className="cu-invoice-pline-icons">
        <IoClose
          size={20}
          className="cursor-pointer"
          onClick={() => deletePLine(idx)}
        />
        <MdAdd
          size={20}
          className="cursor-pointer"
          color="red"
          onClick={addPLine}
        />
      </div>
    </div>
  );
};

export default PLine;
